import {FC} from 'react';

import DropdownInput, {DropdownInputProps} from './DropdownInput';
import DropdownSelect, {DropdownSelectProps} from './DropdownSelect';

export type BaseDropdownProps = DropdownInputProps | DropdownSelectProps;

const BaseDropdown: FC<BaseDropdownProps> = ({type = 'select', ...props}) => {
    if (type === 'select') {
        return <DropdownSelect {...(props as DropdownSelectProps)} />;
    }

    if (type === 'input') {
        return <DropdownInput {...(props as DropdownInputProps)} />;
    }

    throw new Error('Invalid type!');
};

export default BaseDropdown;
